import { isPhone } from '@helpers';

export interface ElementSizeConfig {
  small: boolean;
  middle: boolean;
  large: boolean;
  ultraLarge: boolean;
}

export const getElementSizeConfig = (batchListWidth: number): ElementSizeConfig => ({
  small: isPhone || batchListWidth < 684,
  middle: !isPhone && batchListWidth >= 684 && batchListWidth <= 1044,
  large: !isPhone && batchListWidth > 1044 && batchListWidth < 1600,
  ultraLarge: !isPhone && batchListWidth >= 1600,
});
